// extracted by mini-css-extract-plugin
module.exports = {"link":"NavigationLink_link__mlCXY","content":"NavigationLink_content__G7z64","text":"NavigationLink_text__cnv1R"};